import React from "react";

import {
  ConditionRenderContext,
  FieldDefinition,
} from "src/base-components/FilterPopover/types";
import { Input } from "src/base-components/Input";

type RefFieldMeta = { entityType?: string; eventType?: string };

const resolvePlaceholder = (field: FieldDefinition): string => {
  const meta = field.meta as RefFieldMeta | undefined;

  if (field.type === "entity_ref" && meta?.entityType) {
    return `Enter ${meta.entityType} ID`;
  }
  if (field.type === "event_ref" && meta?.eventType) {
    return `Enter ${meta.eventType} ID`;
  }
  return "Enter ID";
};

export const RefValueRenderer: React.FC<ConditionRenderContext> = ({
  groupIndex,
  conditionIndex,
  field,
  value,
  onChange,
  error,
}) => (
  <Input
    data-loc={`group-${groupIndex}-condition-${conditionIndex}-value`}
    errored={Boolean(error)}
    fullWidth
    placeholder={resolvePlaceholder(field)}
    value={value}
    monospaced
    onChange={(e) => onChange(e.target.value)}
  />
);
